<template>
  <div
    class="d-flex justify-content-start align-content-center text-text-left flex-wrap gap-2"
  >
    <img
      v-if="isFirstName"
      alt=""
      aria-hidden="true"
      :src="profileImage"
      class="visitor-row-profile-image"
    />

    <!-- NAME -->
    <div class="my-auto visitor-row-name">
      {{ isFirstName ? visitor.profile.first_name : visitor.profile.last_name }}
    </div>
    <!-- NAME -->

    <!-- DATE OF BIRTH (keyboard-accessible; tooltip text duplicated for SR) -->
    <button
      v-if="isLastNameAndValidDob"
      type="button"
      class="btn btn-link p-0 border-0 align-self-center visitor-dob-info-btn"
      :aria-label="dateOfBirthTooltip"
      :title="dateOfBirthTooltip"
    >
      <i class="ri-information-line" aria-hidden="true" />
    </button>
  </div>
</template>

<script>
import moment from "moment-timezone"
import { computed } from "vue"

export default {
  name: "VisitorNameColumn",
  props: {
    visitor: {
      type: Object,
      default: () => ({})
    },
    isFirstName: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const profileImage = computed(() => {
      return (
        props?.visitor?.profile?.profile_image_uri ||
        props?.visitor?.profile?.profile_image_thumbnail_uri ||
        "/img/avatars/user-avatar.jpeg"
      )
    })

    const dateOfBirthTooltip = computed(() => {
      return `Date of Birth: ${sanitizeDate(
        props?.visitor?.profile?.date_of_birth
      )}`
    })

    const isLastNameAndValidDob = computed(() => {
      return (
        !props.isFirstName &&
        sanitizeDate(props?.visitor?.profile?.date_of_birth)
      )
    })

    const sanitizeDate = (date) => {
      if (date == null || date === "") return null
      if (date instanceof Date && !isNaN(date.getTime())) {
        const m = moment(date)
        return m.isValid() ? m.format("MM-DD-YYYY") : null
      }
      if (typeof date === "number" && !Number.isNaN(date)) {
        const m = moment(date)
        return m.isValid() ? m.format("MM-DD-YYYY") : null
      }

      const s = String(date).trim()
      if (!s) return null

      const strictFormats = [
        moment.ISO_8601,
        "YYYY-MM-DD",
        "MM/DD/YYYY",
        "M/D/YYYY",
        "MM/DD/YY",
        "MM-DD-YYYY",
        "M-D-YYYY"
      ]

      for (const fmt of strictFormats) {
        const m =
          fmt === moment.ISO_8601
            ? moment(s, moment.ISO_8601, true)
            : moment(s, fmt, true)
        if (m.isValid()) return m.format("MM-DD-YYYY")
      }

      const loose = moment(s)
      return loose.isValid() ? loose.format("MM-DD-YYYY") : null
    }

    return {
      profileImage,
      isLastNameAndValidDob,
      dateOfBirthTooltip
    }
  }
}
</script>

<style scoped></style>
